// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__h7rrI","body":"style__body__cC5A6","whiteBody":"style__whiteBody__zFyVI"};